import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { catchError, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { Applications, ISignal, RolePermissionsModel } from '../../../../shared/models/app.model';
import { profileModificationModel, UPEnums, UPGeneralFields, UPSalesFields, UPServiceFields } from '../../model/user-profile.model';
import { CommonService } from '../../../../shared/services/common.service';
import { UserProfileService } from '../../services/user-profile.service';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-user-profile-popup',
    templateUrl: './user-profile-popup.component.html',
    styleUrl: './user-profile-popup.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserProfilePopupComponent implements OnInit, AfterViewInit, OnDestroy {
  isResetAuthDisabled: boolean = false;
  modifiedSections: any = {};
  private destroy$: Subject<any>;
  isUserActive: boolean = false;
  @Input('userProfile') userProfile: any;
  @Output() closePopup = new EventEmitter();
  action: Subject<ISignal>;
  UPGeneralFields: typeof UPGeneralFields = UPGeneralFields;

  genUserData: any;
  PERMISSIONS: RolePermissionsModel[] = [];
  UPEnums: typeof UPEnums = UPEnums;
  UserProfileService: typeof UserProfileService = UserProfileService;

  enableSaveButton: boolean = false;
  // reloadEntirePopup: boolean = true;
  reloadSection: 'gen' | 'sales' | 'service' | 'ALL' | '' = '';
  lockAccountButtonText: string = 'Unlocked';
  userId: string = '';
  isCreatingNewUser: boolean = false;
  initialLoad: boolean = false;
  isUserEnabled: boolean;
  intervalId: any;
  saveAndClose: boolean;
  receivedUpdatedProfilesData: any = {};
  // CREATE_VIEW_PERMISSIONS: any;


  constructor(private commonService: CommonService, private usersService: UserProfileService) {
    this.userProfile = {[UPGeneralFields.userId]: ''};
    this.action = new Subject();
    this.destroy$ = new Subject();
    this.modifiedSections[UPEnums.GeneralAddresses] = false;
    this.modifiedSections[UPEnums.GeneralFormData] = false;
    this.modifiedSections[UPEnums.GeneralProfilePic] = false;
    
    this.modifiedSections[UPEnums.ServicesFormData] = false;
    this.modifiedSections[UPEnums.ServicePreferencesData] = false;
    this.modifiedSections[UPEnums.ServicesBusinessLogo] = false;

    this.modifiedSections[UPEnums.SalesFormData] = false;
    this.modifiedSections[UPEnums.SalesAssignmentsData] = false;
    this.modifiedSections[UPEnums.SalesPreferencesData] = false;
  }
  ngAfterViewInit(): void { }
  ngOnInit(): void {
    // this.intervalId  = setInterval(() => {
    //   console.log("this.modifiedSections ==>", this.modifiedSections);
    // }, 5000);
    this.initialLoad = false;
    this.userId = this.userProfile?.[UPGeneralFields.userId];
    this.isCreatingNewUser = !this.userProfile?.[UPGeneralFields.userId];
    this.checkMFAStatus();
    this.checkAccountStatus();
    this.loadPermissions();
  }

  handleSubjects() {
     // Subscribe to track when all API calls are done
      //  const b = document.querySelector('#modal-body');
      // this.intervalId = setInterval(() => {
      //// console.log("document.scrollingElement ");;
      //   requestAnimationFrame(() => {
      //       window.scrollTo({
      //         top: 0,
      //         behavior: 'smooth'
      //       });
      //     });
      // }, 200);

  
     this.usersService.allCallsCompleted$.pipe(takeUntil(this.destroy$)).subscribe((allCompleted) => {
      if (allCompleted) {
        if(!this.initialLoad) {
          this.action.next({action: 'allSectionsLoaded', data: null});
          
          this.initialLoad = true;
        }
        setTimeout(() => {
          const allSectionsSaved = Object.values(this.modifiedSections).every(val => val === false && val !== undefined);
          if (allSectionsSaved === true) {
          if(this.saveAndClose) {
              console.log("this.modifiedSections before closing ==>", this.modifiedSections);
              // alert("Everything saved, now shall we proceed closing?");
              this.saveAndClose = false;
              this.closePopup.emit(true);
            } else {
              const messagesObj: any[] = this.usersService.apiMessages?.filter(f => f.isSuccessfull);
              if(messagesObj?.length) {
                const result = [];
                for (let item of messagesObj) {
                  if (/successfully/i.test(item.message)) {
                    // do nothing
                  } else {
                    // messages other than Data Saved Successfuly are being populated in result here.
                    result.push(item);
                  }
                }
                if(result?.length > 0) {
                  this.commonService.showNotification("success", result[0].message)
                } else {
                  this.commonService.showNotification("success", "Data saved successfully!")
                }
  
              }
  
            }
            this.usersService.apiMessages = [];
          } else { // some apis failed after all apis completed and the sections are unsaved afterwards
            if(this.usersService.apiMessages?.filter(f => !f.isSuccessfull)?.length) {
              this.commonService.showNotification("error", this.usersService.apiMessages?.filter(f => !f.isSuccessfull)[0].message);
              this.usersService.apiMessages = [];
            }
          }          
        }, 1000);
        UserProfileService.apiCallsInProgress = [];
        
      }
    });

    this.usersService.hitSaveAll.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if(this.usersService.invalidDataSections?.length == 0)
        {
          this.action.next({ action: 'saveAll', data: null });
        } else {
       // console.log("Cannot save data due to validation errors in some sections. Sections are =>", this.usersService.invalidDataSections.join(', '));
          this.commonService.showNotification('info', 'Cannot save data due to validation errors in some sections.');
        }
    });
    
    this.usersService.hasGeneralFormSavedSuccessfuly.pipe(takeUntil(this.destroy$)).subscribe({
      next: res => {
        res && this.action.next({ action: 'saveAll', data: null });
      }
    });
  }
  checkAccountStatus() {
    this.usersService.apiCallStarted('checkAccountStatus');
    this.usersService.checkkAccountLock(this.userId).subscribe({
      next: (res: any) => {
        if(res?.result?.status == 'Unlocked') {
          this.lockAccountButtonText = res?.result?.status
        } else {
          this.lockAccountButtonText = 'Unlock Account'
        }
        this.usersService.apiCallCompleted('checkAccountStatus');
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted('checkAccountStatus');
      }
    });
  }

  unlockAccount() {
    this.usersService.apiCallStarted('unlockAccount');
    this.usersService.unlockAccount(this.userId).subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        if(res?.result?.status == 'Unlocked') {
          this.lockAccountButtonText = res?.result?.status;
        }
        this.usersService.apiCallCompleted('unlockAccount');
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted('unlockAccount');
      }
    });
  }

  checkMFAStatus() {
    this.usersService.apiCallStarted("checkMFAStatus");
    this.usersService.checkMFAStatus(this.userId).subscribe({
      next: (res: any) => {
        if(res?.result?.status == 'Set') {
          this.isResetAuthDisabled = false;
        } else {
          this.isResetAuthDisabled = true;
        }
        this.usersService.apiCallCompleted("checkMFAStatus");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("checkMFAStatus");
      }
    });
  }

  resetAuth() {
    this.usersService.apiCallStarted("resetAuth");
    this.usersService.resetMFA(this.userId).subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        if(res?.result?.status == 'Set') {
          this.isResetAuthDisabled = false;
        } else {
          this.isResetAuthDisabled = true;
        }
        this.usersService.apiCallCompleted("resetAuth");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("resetAuth");
      }
    });
  }
  setChangePasswordFlag() {
    this.usersService.apiCallStarted("setChangePasswordFlag");
    this.usersService.setChangePasswordFlag(this.userId).subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        this.usersService.apiCallCompleted("setChangePasswordFlag");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("setChangePasswordFlag");
      }
    });
  }

  resetProfilePersistence() {
    this.usersService.apiCallStarted("resetProfilePersistence");
    this.usersService.clearPersistence(this.userId, "").subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        this.usersService.apiCallCompleted("resetProfilePersistence");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("resetProfilePersistence");
      }
    });
  }
  loadPermissions(
    category: string = 'userProfilePopup_Footer',
    subCategory: string = '',
    id: string = '',
    module: string = 'userProfile'
  ) {
    this.commonService.getRolePermission(category, subCategory, module, this.userProfile?.[UPGeneralFields.userId]).subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        this.PERMISSIONS.map((permission: RolePermissionsModel) => {
          permission.ruleAction = permission.ruleAction.replace('MP_', '').replace('UP_', '');
        });

        this.updatePagePermissions().then(() => {
          this.handleSubjects();
        });
      },
      error: (err: any) => {
        this.PERMISSIONS = [];
      }
    });
  }
  updatePagePermissions(): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, 20);

    });
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  saveButtonClick(saveAndOption?: 'Save & Close' | 'Save & Activate' | 'Save & Deactivate') {
    // Reset all validation errors from any previous save attempt so this round
    // starts with a completely clean slate.
    this.usersService.resetInvalidDataSections();

    this.action.next({ action: 'checkValidations', data: null });
    this.usersService.apiCallStarted('checkUserProfileValidations');
    setTimeout(() => {
      if (this.usersService.invalidDataSections?.length == 0) {
        saveAndOption === 'Save & Close' && (this.saveAndClose = true);
        if (this.usersService.hasGeneralFormChanged) {
          this.action.next({ action: 'saveGeneralFormData', data: saveAndOption });
        } else {
          if (saveAndOption === 'Save & Deactivate') {
            this.enableDisableApp(false);
          } else if (saveAndOption === 'Save & Activate') {
            this.enableDisableApp(true);
          } else {
            this.action.next({ action: 'saveAll', data: null });
          }
        }
      } else {
        // Validation errors exist — individual section handlers have already
        // shown specific notifications for each error.
        console.warn('Save blocked. Invalid sections:', this.usersService.invalidDataSections);
      }
      this.usersService.apiCallCompleted('checkUserProfileValidations');
    }, 1200);
  }
  enableDisableApp(toggle: boolean, app: Applications | '' = '') {
    this.usersService.enableDisableApplication(this.userId, app, toggle).subscribe({
      next:(res: any) => {
        // this.sectionModified({modified: false, section: UPEnums.GeneralEnableCb, reloadPopup: true});
        this.onProfileModified({
          modified: false,
          reloadSection: 'ALL'
        })
        // this.isSectionEnabled = toggle;
      },
      error: (err: any) => {
        // this.isSectionEnabled = !toggle;
        // this.generalEnableCb.checked = !toggle;
      //   this.commonService.showNotification("error", err?.error?.message);
      // this.sectionModified({modified: false, section: UPEnums.GeneralEnableCb});
      }
    });
  }
  checkUnsavedDataBeforeClosing(from: string, data?: any) {
    let hasUnsavedChanges = Object.keys(this.modifiedSections).some(key => this.modifiedSections[key] === true);
    
      const hasRoleSelectedInAnySection = !!this.receivedUpdatedProfilesData[UPEnums.ServicesFormData]?.[UPServiceFields.role] || !!this.receivedUpdatedProfilesData[UPEnums.SalesFormData]?.[UPSalesFields.role];
      const mustCreateUserInOneSection = !hasRoleSelectedInAnySection && this.userId;
      if(mustCreateUserInOneSection) {
        this.commonService.showConfirmation("The user has not been assigned to any application and no role has been selected. Only General Information has been completed. Are you sure you want to close the popup?")
      .then(res => {
        if (res.isConfirmed) {
          this.closePopup.emit(true);
        }
      });
      } else if(hasUnsavedChanges) {
        this.commonService.showConfirmation("Any unsaved changes will be lost, are you sure to close the popup?")
      .then(res => {
        if (res.isConfirmed) {
          this.closePopup.emit(true);
        }
      });
      
    } else {
      this.closePopup.emit(true);
    }
  }
  receiveProfileDataFromChild(e: any) {
    this.receivedUpdatedProfilesData[e?.section] = e.data;
  }
  
  onProfileModified(e: profileModificationModel) {
    const isDataModified = e.modified;
    // const reloadPopup = !!e?.reloadSection;
    const reloadPermissionsOnDataSave = !!e.updatedPermissiosParameters;

    // either disable section - shall not reload but shall reset the section unsaved changes
    // or reload section - resets as a result of this action?? (Would reset automatically or would need to be done manually???).
    // if(!isDataModified) { // if modified false for entire section, then mark that entire section as unchanged!
      switch (e?.reloadSection) { 
        // When a section disabled, it shall be reloaded + the section unsaved changes shall reset. 
        case 'gen':
          this.modifiedSections[UPEnums.GeneralAddresses] = false;
          this.modifiedSections[UPEnums.GeneralFormData] = false;
          this.modifiedSections[UPEnums.GeneralProfilePic] = false;
          // this.modifiedSections[UPEnums.GeneralEnableCb] = false; // not sure about this one     
          this.reloadSection = e?.reloadSection;
          setTimeout(() => {
            this.reloadSection = '';
          }, 1000);
          break;
          case 'sales':
          this.modifiedSections[UPEnums.SalesAddresses] = false;
          this.modifiedSections[UPEnums.SalesAssignmentsData] = false;
          this.modifiedSections[UPEnums.SalesFormData] = false;
          this.modifiedSections[UPEnums.SalesPreferencesData] = false;    
          this.reloadSection = e?.reloadSection;
          setTimeout(() => {
            this.reloadSection = '';
          }, 1000);         
          break;
        case 'service':
          this.modifiedSections[UPEnums.ServicePreferencesData] = false;
          this.modifiedSections[UPEnums.ServicesBusinessLogo] = false;
          this.modifiedSections[UPEnums.ServicesFormData] = false;   
          this.reloadSection = e?.reloadSection;
          setTimeout(() => {
            this.reloadSection = '';
          }, 1000);
          break;

        case 'ALL': // shall reload the popup
            Object.keys(this.modifiedSections).forEach(key => this.modifiedSections[key] = false);
              this.reloadSection = e?.reloadSection;
              setTimeout(() => {
                this.reloadSection = '';
              }, 0);
          break;
      }
      e.modified != undefined && (this.modifiedSections[e.section] = e.modified);
    // }

    // e.modified != undefined && ![UPEnums.GeneralEnableCb].includes(e.section) && (this.modifiedSections[e.section] = isDataModified);
 // console.log("this.modifiedSections == ", Object.entries(this.modifiedSections).filter(([key, value]) => value === true).map(([key]) => key));

    if(reloadPermissionsOnDataSave) {
      this.action.next({ action: 'reloadPermissions', data: e.updatedPermissiosParameters });
    }
    if(e.userProfile) this.userProfile = e.userProfile;
    if(e.userProfile) this.userId = e.userProfile[UPGeneralFields.userId];

    this.isCreatingNewUser = !this.userProfile?.[UPGeneralFields.userId];
    this.isUserEnabled = !!this.userProfile?.[UPGeneralFields.isEnabled];

    // if(reloadPopup) {
      
    // }
    this.enableSaveButton = Object.keys(this.modifiedSections).some(key => this.modifiedSections[key] === true);
  }

  ngOnDestroy(): void {
    this.destroy$.next(false);
    this.destroy$.complete();
    this.usersService.apiMessages = [];
    this.initialLoad = false;
    clearInterval(this.intervalId);
    // clearInterval(this.intervalId);
  }

}

